import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxTooltipParams } from '../../../models/rx-tooltip-params';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'rx-applications-custom-tooltip',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss'],
})
export class CustomTooltipComponent {
  params: RxTooltipParams;
  testId: string;

  agInit(params: RxTooltipParams): void {

    this.testId = params?.colDef?.tooltipComponentParams?.testId || 'test-custom-tooltip';
    this.params = params;
  }
}
